<template>
  <div class="failed">
    <h2>Anmeldung am System fehlgeschlagen.</h2>
  </div>
</template>
